module.exports = __webpack_public_path__ + "static/img/Frame731.1b61ef2b.png";